<template>
  <div class="container">
    <el-row class="formcenter demo-block demo-box demo-zh-CN demo-form">
      <el-col :span="24 ">
        <img class="imgsize" src="http://kaisuoshop.oss-cn-beijing.aliyuncs.com/surenordic/goods/bg1.png">
      </el-col>
    </el-row>
    <el-row class="formcenter demo-block demo-box demo-zh-CN demo-form">
    <el-col :span="24">
      <div >
        <span>商品名称：云杉啤酒（Spruce Beer）</span>
        <span>售价：0.01</span>
      </div>
    </el-col>
    </el-row>
    <el-row class="formcenter demo-block demo-box demo-zh-CN demo-form">
      <el-col :span="24">
        <el-button type="primary" class="btnsize" size="medium" @click="onPay">确认支付</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import { Message } from 'element-ui'
var wxinfo = wx
export default {
  name: 'WxJsTest',
  mounted: function () {
    document.getElementsByTagName('title')[0].innerText = '订单详情'
    var packageinfo
    if (getCookie('package') != null) {
      packageinfo = getCookie('package')
    } else {
      alert('package包头文件缺失')
    }
    var timestamp = Date.parse(new Date()).toString()
    timestamp = timestamp.substr(0, 10)
    var nonce = randomWord(false, 30)
    var that = this
    var appid, sha1signature, md5signature
    that.$http.get('https://app.surenordic.cn/getwxauth?timestamp=' + timestamp + '&nonce=' + nonce + '&package=' + packageinfo, {
    }, {
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      }
    })
      .then(function (res) {
        console.log('已获取网络数据')
        if (res.status === 200) {
          console.log(res.data)
          appid = res.data.appid
          sha1signature = res.data.sh1signature
          md5signature = res.data.md5signature
          console.log(md5signature)
          wxinfo.config({
            debug: false,
            appId: appid,
            timestamp: timestamp,
            nonceStr: nonce,
            signature: sha1signature,
            jsApiList: [
              'checkJsApi',
              'chooseWXPay'
            ]
          })
        }
      })
      .catch(function (error) {
        console.log('error' + error)
      })
  },
  methods: {
    onPay: function () {
      var packageinfo
      if (getCookie('package') != null) {
        packageinfo = getCookie('package')
      } else {
        alert('package包头文件缺失')
      }
      var timestamp = Date.parse(new Date()).toString()
      timestamp = timestamp.substr(0, 10)
      var nonce = randomWord(false, 30)
      var that = this
      var appid, sha1signature, md5signature
      that.$http.get('https://app.surenordic.cn/getwxauth?timestamp=' + timestamp + '&nonce=' + nonce + '&package=' + packageinfo, {
      }, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      })
        .then(function (res) {
          console.log('已获取网络数据')
          console.log(md5signature)
          if (res.status === 200) {
            console.log(res.data)
            appid = res.data.appid
            sha1signature = res.data.sh1signature
            md5signature = res.data.md5signature
            wxinfo.config({
              debug: false,
              appId: appid,
              timestamp: timestamp,
              nonceStr: nonce,
              signature: sha1signature,
              jsApiList: [
                'checkJsApi',
                'chooseWXPay'
              ]
            })
            wxinfo.chooseWXPay({
              timestamp: timestamp,
              nonceStr: nonce,
              package: packageinfo,
              signType: 'MD5', // 注意：新版支付接口使用 MD5 加密
              paySign: md5signature,
              success: function (res) {
                Message.success('支付成功')
              }
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  }
}
function randomWord (randomFlag, min, max) {
  var str = ''
  var range = min
  var arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
  // 随机产生
  if (randomFlag) {
    range = Math.round(Math.random() * (max - min)) + min
  }
  for (var i = 0; i < range; i++) {
    var pos = Math.round(Math.random() * (arr.length - 1))
    str += arr[pos]
  }
  return str
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>
<style scoped>
  .imgsize {
    width:150px;
    height:239px;
  }
  .btnsize {
    width: 180px;
  }
  .formcenter {
    text-align:center
  }
  .container {
    margin-top: 24px;
    padding: 20px;
    background-color: #fff;
  }
  .demo-box {
    padding: 20px;

  }
  .demo-block {
    border-radius: 3px;
    transition: .2s;
  }
  .formdiv {
    padding: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/wx/WxJsTest.vue